/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiProgress } from '@elastic/eui'

import { getBalanceColor } from './utils'

type Props = {
  current: number
  max: number
}

const ProgressBar: FunctionComponent<Props> = ({ current, max }) => {
  const color = getBalanceColor(current, max)

  return (
    <EuiProgress
      data-test-id='balance-progress-bar'
      value={current}
      color={color}
      max={max}
      size='m'
    />
  )
}

export default ProgressBar
